import { API, graphqlOperation } from 'aws-amplify';
import { getUser } from 'graphql/user/queries';
import { arrayToObj, createReducer, getError } from 'utils/appHelpers';
import store from 'redux/store';
import { followUserMutation, unFollowUserMutation } from 'graphql/user/mutations';

const ON_LOGOUT = '@@auth/ON_LOGOUT';
const ON_FOLLOWS_SET = '@@home/ON_FOLLOWS_SET';

const initialFollows = {
  followers: {},
  following: {},
};

const followsHandlers = {
  [ON_FOLLOWS_SET]: (state, action) => action.payload,
  [ON_LOGOUT]: () => initialFollows,
};

export const onGetFollows = async () => {};

export const getUserFollows = async id => {
  try {
    const body = { limit: 1000, id };
    const { data } = await API.graphql(graphqlOperation(getUser, body));
    const following = arrayToObj(data.getUser.followees.items, 'id');
    const followers = arrayToObj(data.getUser.followers.items, 'id');
    store.dispatch(onSetFollows({ following, followers }));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const followUser = async user => {
  try {
    const follows = store.getState().follows;
    const body = { id: user.id };
    const { data } = await API.graphql(graphqlOperation(followUserMutation, body));
    if (data.followUser.error) throw new Error(getError(data.followUser.error));
    follows.following[user.id] = user;
    store.dispatch(onSetFollows({ ...follows, following: follows.following }));
  } catch (err) {
    throw err;
  }
};

export const unFollowUser = async user => {
  try {
    const follows = store.getState().follows;
    const body = { id: user.id };
    const { data } = await API.graphql(graphqlOperation(unFollowUserMutation, body));
    if (data.unfollowUser.error) throw new Error(getError(data.unfollowUser.error));
    delete follows.following[user.id];
    store.dispatch(onSetFollows({ ...follows, following: follows.following }));
  } catch (err) {
    throw err;
  }
};

export const onToggleFollows = async user => {
  try {
    const follows = store.getState().follows;
    if (follows.following[user.id]) {
      await unFollowUser(user);
    } else {
      await followUser(user);
    }
  } catch (err) {
    throw err;
  }
};

export const onSetFollows = payload => ({ type: ON_FOLLOWS_SET, payload });

export const followsReducer = createReducer(initialFollows, followsHandlers);
